module.exports = __webpack_public_path__ + "img/20 Animation 2-squashed.922c39ff.jpg";